import { useTranslation } from 'react-i18next';
import {
  FrequenciaTipoEnum
} from '../../../../enum/lancamento-aula/frequencia-tipo.enum';
import {
  SelectOptionInterface
} from '../../../../interfaces/lancamento-aula/step-2/select-option.interface';
import PresencaSelectOption from '../select-options/presenca-select-option.component';

export default function useFrequenciaSection() {
  const { t } = useTranslation('gestao_de_aulas');
  const frequenciaOption: SelectOptionInterface[] = [
    {
      label: <PresencaSelectOption t={t} value={FrequenciaTipoEnum.PRESENTE} />,
      value: FrequenciaTipoEnum.PRESENTE
    },
    {
      label: <PresencaSelectOption t={t} value={FrequenciaTipoEnum.ATRASADO} />,
      value: FrequenciaTipoEnum.ATRASADO
    },
    {
      label: <PresencaSelectOption t={t} value={FrequenciaTipoEnum.AUSENTE} />,
      value: FrequenciaTipoEnum.AUSENTE
    }
  ];

  return {
    frequenciaOption,
  };
}
